const fmt = (n, dp = 2) =>
  Number.isFinite(+n) ? Number(n).toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp }) : "—";

export default function Receipt({ tx }) {
  if (!tx) return null;
  return (
    <div id="print-receipt" className="hidden print:block">
      <div style={{ textAlign: "center", marginBottom: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>RIYADH-NUSANTARA FX</div>
        <div style={{ fontSize: 10 }}>SAR — IDR — USDT Money Changer</div>
        <div style={{ fontSize: 9 }}>Riyadh Branch</div>
      </div>
      <div style={{ borderTop: "1px dashed #000", borderBottom: "1px dashed #000", padding: "4px 0", margin: "4px 0" }}>
        <div>TX: {tx.tx_number}</div>
        <div>{new Date(tx.created_at).toLocaleString()}</div>
        <div>Teller: {tx.created_by_name}</div>
        <div>Customer: {tx.customer_name || "Walk-in"}</div>
      </div>
      {(tx.legs || []).map((l, i) => (
        <div key={i} style={{ margin: "6px 0" }}>
          <div style={{ fontWeight: 700 }}>Leg {i + 1}: {l.from_currency} → {l.to_currency}</div>
          <div>Amount: {fmt(l.from_amount, 2)} {l.from_currency}</div>
          <div>Rate: {fmt(l.rate, 4)}</div>
          <div>Received: {fmt(l.to_amount, l.to_currency === "USDT" ? 4 : 0)} {l.to_currency}</div>
        </div>
      ))}
      <div style={{ borderTop: "1px dashed #000", paddingTop: 4, marginTop: 6 }}>
        <div>Profit: Rp {fmt(tx.total_profit_idr, 0)}</div>
        <div>Status: {tx.status?.toUpperCase()}</div>
      </div>
      {tx.notes && <div style={{ marginTop: 4, fontStyle: "italic" }}>Notes: {tx.notes}</div>}
      <div style={{ textAlign: "center", marginTop: 10, fontSize: 10 }}>
        Thank you for your business
        <div style={{ marginTop: 8, borderTop: "1px solid #000", paddingTop: 4 }}>Cashier Signature</div>
      </div>
    </div>
  );
}
